import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles.css';

const Header = () => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="page-header">
      <div className="container d-flex justify-content-between align-items-center">
        <div className="logo">
          <img src="/images/logo.png" alt="ABAY Token" className="header-logo" />
        </div>
        <div className="hamburger">
          <button
            className={`hamburger-label ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            aria-controls="top-menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <nav
          id="top-menu"
          className={`top-menu ${isMenuOpen ? 'open' : ''}`}
          role="navigation"
        >
          {token ? (
            <>
              <Link
                to="/presale"
                className={`btn mx-1 ${location.pathname === '/presale' ? 'btn-light' : 'btn-outline-light'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Buy Token
              </Link>
              <Link
                to="/dashboard"
                className={`btn mx-1 ${location.pathname === '/dashboard' ? 'btn-light' : 'btn-outline-light'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Dashboard
              </Link>
              <Link
                to="/transaction-detail"
                className={`btn mx-1 ${location.pathname === '/transaction-detail' ? 'btn-light' : 'btn-outline-light'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Transactions
              </Link>
              <Link
                to="/profile"
                className={`btn mx-1 ${location.pathname === '/profile' ? 'btn-light' : 'btn-outline-light'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Profile
              </Link>
              <Link
                to="/leadboard"
                className={`btn mx-1 ${location.pathname === '/leadboard' ? 'btn-light' : 'btn-outline-light'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Referral Leaderboard
              </Link>
              <button
                onClick={() => {
                  handleLogout();
                  setIsMenuOpen(false);
                }}
                className="btn btn-outline-light mx-1"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className={`btn mx-1 ${location.pathname === '/login' ? 'btn-light' : 'btn-outline-light'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Login
              </Link>
              <Link
                to="/register"
                className={`btn mx-1 ${location.pathname === '/register' ? 'btn-light' : 'btn-outline-light'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Register
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
